import React from 'react';
import { useNavigate } from 'react-router-dom';

// `isActive` is resolved centrally in `Sidebar.js` via `resolveActiveLink` so
// that only one link can be active at a time; this component just renders it.
const SidebarLink = ({ to, label, isActive = false }) => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(to)}
      aria-current={isActive ? 'page' : undefined}
      className={`
        relative block w-full text-left text-sm rounded-md px-3 py-1.5
        transition-all duration-150
        ${isActive
          ? 'text-text bg-mix/[0.06] font-medium'
          : 'text-text-muted hover:text-text-secondary hover:bg-mix/[0.04]'
        }
      `}
    >
      {isActive && (
        <span className="absolute left-0 top-1.5 bottom-1.5 w-[2px] rounded-r bg-primary" />
      )}
      <span className={isActive ? 'pl-1.5' : ''}>{label}</span>
    </button>
  );
};

export default SidebarLink;
